import { useDispatch } from "react-redux";
import "./Messages.scss";
import { sessionAPI } from "../../api/sessionAPI.mjs";
import { addMessage } from "../../store/slices/sessionSlice.mjs";
export default function Button({ text }) {
  const dispatch = useDispatch();
  return (
    <button
      className="message__button"
      onClick={() => {
        dispatch(addMessage(text));
        sessionAPI.sendMessage({ message: text });
      }}
    >
      {text}
    </button>
  );
}
